import { put, call } from 'redux-saga/effects';
import { Types } from './actions';
import ReinforcementRepository from '../../../repositories/ReinforcementRepository';
import ReinforcementDataRepository from '../../../../data/repositories/ReinforcementDataRepository';

export default function* execute(action: any): any {
  try {
    yield put({ type: Types.UNSUBSCRIBE_TO_REINFORCEMENT_REQUEST });
    const { code } = action;
    const reinforcementRepository: ReinforcementRepository =
      new ReinforcementDataRepository();
    const reinforcementResponse = yield call(
      reinforcementRepository.unsubscribeReinforcements,
      code
    );
    if (!reinforcementResponse) {
      yield put({
        type: Types.UNSUBSCRIBE_TO_REINFORCEMENT_FAILURE,
        error: 'Ocurrió un error al momento de anular la suscripción.'
      });
    }
    yield put({
      type: Types.UNSUBSCRIBE_TO_REINFORCEMENT_SUCCESS,
      data: reinforcementResponse
    });
  } catch (error) {
    yield put({
      type: Types.UNSUBSCRIBE_TO_REINFORCEMENT_FAILURE,
      error: 'Ocurrió un error al momento de anular la suscripción.'
    });
  }
}
